// @ts-expect-error Lexxy does not have types
import { Extension } from "@37signals/lexxy"

// Makes the toolbar collapsible through the collapse controller (see notes/_collapse_toggle).
// Disabled by default: only editors configured with `collapsible_toolbar` opt in.
export default class CollapsibleToolbarExtension extends Extension {
  declare editorElement: HTMLElement & { config: { get(path: string): unknown } }

  get enabled() {
    return this.editorElement.config.get("collapsible_toolbar") === true
  }

  initializeToolbar(toolbar: HTMLElement) {
    toolbar.id = "note_toolbar"
    toolbar.classList.add("collapse", "show", "no-transition")
    toolbar.dataset.controller = "collapse"
  }
}
